import { useQuery } from "@tanstack/react-query";

import { analyticsApi, type BalanceResponse } from "@/api/analyticsApi";

export const BALANCE_QUERY_KEYS = {
  ALL: ["balance"],
};

export function useBalance() {
  return useQuery<BalanceResponse>({
    queryKey: BALANCE_QUERY_KEYS.ALL,
    queryFn: () => analyticsApi.getBalance(),
    refetchInterval: 60000, // Обновление каждую минуту
  });
}
